import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { IntakeProvider } from "./lib/intake-context";
import { ThemeProvider } from "./lib/theme-context";
import { useTheme } from "./lib/theme-context-value";
import WelcomePage from "./pages/WelcomePage";
import StartPage from "./pages/StartPage";
import PrescreenPage from "./pages/PrescreenPage";
import ConsentPage from "./pages/ConsentPage";
import QualifiedPage from "./pages/QualifiedPage";
import NotQualifiedPage from "./pages/NotQualifiedPage";

export default function App() {
  return (
    <ThemeProvider>
      <IntakeProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[var(--color-leap21-bg)]">
            <header className="h-14 bg-white flex items-center gap-2 px-3 sm:px-6 sticky top-0 z-10" style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.04)" }}>
              <span className="font-bold text-[14px] text-gray-900" style={{ letterSpacing: "-0.2px" }}>
                Leap21
              </span>
              <span className="text-[11px] uppercase tracking-wider text-gray-500 truncate">
                Clinical Trial Registry
              </span>
              <ThemeSelect />
            </header>
            <main className="max-w-xl mx-auto px-6 py-10">
              <Routes>
                <Route path="/apply/vesper5/welcome" element={<WelcomePage />} />
                <Route path="/start" element={<StartPage />} />
                <Route path="/prescreen" element={<PrescreenPage />} />
                <Route path="/consent" element={<ConsentPage />} />
                <Route path="/qualified" element={<QualifiedPage />} />
                <Route path="/not-qualified-registry" element={<NotQualifiedPage />} />
                <Route path="*" element={<Navigate to="/apply/vesper5/welcome" replace />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </IntakeProvider>
    </ThemeProvider>
  );
}

function ThemeSelect() {
  const { theme, setTheme } = useTheme();
  return (
    <label className="ml-auto flex shrink-0 items-center gap-1.5 text-xs text-gray-700">
      Theme
      <select
        aria-label="Theme"
        value={theme}
        onChange={(event) => setTheme(event.target.value as "light" | "dark" | "system")}
        className="h-11 rounded-md border border-gray-300 bg-white px-2 text-xs text-gray-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
      >
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="system">System</option>
      </select>
    </label>
  );
}
